import { render, staticRenderFns } from "./UpdatePrice.vue?vue&type=template&id=6acc7c3e&scoped=true"
import script from "./UpdatePrice.vue?vue&type=script&lang=js"
export * from "./UpdatePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc7c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acc7c3e')) {
      api.createRecord('6acc7c3e', component.options)
    } else {
      api.reload('6acc7c3e', component.options)
    }
    module.hot.accept("./UpdatePrice.vue?vue&type=template&id=6acc7c3e&scoped=true", function () {
      api.rerender('6acc7c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/ProductConfig/dialogs/UpdatePrice.vue"
export default component.exports